import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How long until I see new clients from LinkedIn?",
    a: "Honest answer: weeks to months. The profile and brand build ships in 14 days. The first qualified conversations usually arrive within 30 days. Real, compounding results — content reach, inbound DMs, repeat referrals — take 60–90+ days. This isn't magic. It's a system that compounds, and we tell you that upfront.",
  },
  {
    q: "I already have a LinkedIn profile — why do I need a brand overhaul?",
    a: "Most finance-firm profiles read like a résumé. We rebuild yours as a brand asset: banner, headline, about, featured, services and proof. Without that foundation, no amount of outreach converts — owners click your profile, see nothing compelling, and disappear.",
  },
  {
    q: "How do you find companies that are actually looking for a finance partner?",
    a: "We use Sales Navigator filters tuned to your ICP plus intent signals (job changes, hiring posts, funding announcements, content engagement with finance topics). We're looking for owners who are already thinking about it — not random cold lists.",
  },
  {
    q: "Will my LinkedIn account get restricted?",
    a: "No. We don't use automation tools that violate LinkedIn's terms. Everything is sent manually within safe daily limits, in your voice, from your account. Slower than spam — and that's the point. It actually builds trust.",
  },
  {
    q: "Do I need LinkedIn Sales Navigator?",
    a: "Yes — it's about $99/mo and worth every dollar. We help you set it up and configure the exact filters for your ICP. Without it, you can't see or target the business owners we want to reach.",
  },
  {
    q: "Is this for bookkeepers only, or any finance firm?",
    a: "We started with bookkeepers and the system extends naturally to other finance firms — fractional CFOs, tax practices, advisory and accounting firms — anyone selling trust-heavy financial services to business owners.",
  },
  {
    q: "Do you write the LinkedIn posts too?",
    a: "Yes. Weekly posts written in your voice, focused on your niche. Designed to build authority over time so business owners DM you first. Included in our Growth and Scale plans.",
  },
  {
    q: "What if I don't see results in the first month?",
    a: "You'll see profile improvements, brand metrics, and the first conversations in month one — but not always a closed client. We're transparent about lead and lag indicators. If the system isn't tracking after 60 days, we'll tell you (and adjust).",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 lg:py-28 border-b border-[#E4E4E7]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#1F4DA0] mb-4">
            FAQ
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
            Questions, answered straight.
          </h2>
          <p className="mt-5 text-base text-[#52525B]">
            Couldn't find what you need? <a href="#contact" className="underline underline-offset-4 text-[#09090B] font-medium">Reach out directly.</a>
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#09090B] last:border-b-0"
              >
                <AccordionTrigger className="font-display font-bold text-lg lg:text-xl text-left py-6 hover:no-underline tracking-tight text-[#09090B]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-[#52525B] leading-relaxed pb-6 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
